import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function ValidateAmount(minAmount:any, maxAmount:any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => { 
        if (!((control.value < maxAmount) && (control.value > minAmount))) {
            return { 'amountInvalid': {
                error:{
                    min: minAmount, 
                    max: maxAmount
                }
            }};
        }
        return null;
    }
}